import React from 'react';
import styled from 'styled-components';

const Span = styled.span`
  line-height: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
`;

const InlineSpanContainer = styled.span`
  line-height: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
`;

const InlineSpan = styled.span`
  line-height: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  vertical-align: inherit;
`;

const InlineFlexSpan = styled(InlineSpan)`
  display: inline-flex;
  align-items: center;
  vertical-align: inherit;
`;

const AddElementToLastWordInString = ({
  text,
  style,
  lastWordStyle,
  children,
}: {
  text: string;
  style?: React.CSSProperties;
  lastWordStyle?: React.CSSProperties;
  children: React.ReactNode;
}) => {
  const wordsArray = text.split(' ');

  if (wordsArray.length > 1) {
    const otherWords = wordsArray.slice(0, -1).join(' ');
    const lastWord = wordsArray[wordsArray.length - 1];

    return (
      <InlineSpanContainer style={style}>
        <InlineSpan dangerouslySetInnerHTML={{ __html: otherWords }} />{' '}
        <InlineFlexSpan style={lastWordStyle}>
          <InlineSpan dangerouslySetInnerHTML={{ __html: lastWord }} /> {children}
        </InlineFlexSpan>
      </InlineSpanContainer>
    );
  }

  return (
    <Span style={lastWordStyle ?? style}>
      {text}
      {children}
    </Span>
  );
};

export default AddElementToLastWordInString;
